export const modifierList = [
  'breaking-news',
  'live',
  'article-heading',
  'article-heading-white',
  'article-heading-edited',
  'article-heading-light',
  'article-heading-dark',
  'article-marker',
  'article-sponsored',
  'editorial-premium',
  'primary-bg-light',
  'inline-gallery',
  'gallery',
  'tag',
  'tag-parsely',
];

export const tagList = ['span', 'a'];
